<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-none element-with-heading" id="uncategorized">
<div class="heading heading-with-title heading-without-image" id="uncategorized-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Book Description</h1>
</div>
</div>
</div>
</div>
<div class="text" id="uncategorized-text">
<p class="first first-in-chapter first-full-width">A chilling tale of African drums and human souls from #1 international bestselling author Kevin J. Anderson and legendary Rush lyricist and drummer Neil Peart.</p>
<p class="subsq">Early in their three decades of correspondence, Neil Peart sent Kevin J. Anderson extensive descriptions and travelogues of his adventures bicycling solo across Africa. Peart painted a vivid and unsettling landscape as memorable as the lyrics to his songs.</p>
<p class="subsq">Anderson, award-winning and bestselling fantasy and science fiction author, used those descriptions as the backdrop for plotting an intense, atmospheric dark fantasy story that followed Peart’s experiences, though with a much more ominous twist. The two used their respective strengths to weave a memorable tale that will linger long after the last page.</p>
<p class="subsq">This special illustrated edition includes Anderson’s new introduction, written after Peart’s death on January 7, 2020, as well as the original Afterword Peart wrote for the story.</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// book-description.vue?1a3c51d3